import React, {useState, forwardRef,useEffect,useRef} from 'react';
import * as S from '../SearchWidget/SearchWidget.styles';
import {useHistory} from 'react-router-dom'
import {SecondaryButton} from '../../../../components/Button/Button';
import Icon from '../../../../../stories/core-components/IconsSelector';
import AutoSuggest from '@stencil/autosuggest';
import {useDispatch,useSelector} from 'react-redux';
import {searchWidgetLocationSearchURL} from './../../../../containers/Common/Api';
import {FROM_PLACEHOLDER, TO_PLACEHOLDER} from './../../../../containers/Common/Constants';
import {CalendarView} from '@stencil/dcalendar';
import dateFormat from 'dateformat';
import * as AutoS from './AutoSuggestList/AutoSuggestList.styles';

import {fetchSrpDataThunk} from './../../../../containers/SRP/redux/thunks'
import {commonSelector,commonDOJ} from './../../../../containers/Common/redux/selectors';
import {updateJourneyParams} from './../../../../containers/Common/redux/actions';
import {scrollEletoView,replaceSRPUrlState} from './../../../../containers/Common/Utils';
import {pushga} from 'ga-utils'
import {SrpGAEvents} from './../../../../config/ga-config';
import getDateObj from './../../../../utils/GetDateObj';
import {setter, getter} from '@stencil/client-side-storage';
import useOutsideClick from './../../../../hooks/useOutsideClick';
import {updateSelectedBus} from './../../../../containers/SRP/redux/actions'
import {getInitSelectedFilters} from './../../../../containers/SRP/Utils'
import { calculateDaysToTrip, convert_yyyymmdd_to_dd_mm_dddd, ctaHelper } from '../../../../utils/ctaHelper'
import { CTA_TYPE, pushOmniEvents } from '../../../../utils/PushEvents/Omniture/utils'
import { pushWebEngageEvents } from '../../../../utils/PushEvents/WebEngage/utils';

const SearchWidget = (props) => {
  const calendarBlockRef = React.createRef();
  
 
  useOutsideClick(calendarBlockRef, () => {
    toggleCalendar(false);

  });

  const history = useHistory();
  const dispatch = useDispatch();
  const commonData = useSelector(commonSelector);
  
  const {doj,dojObj,src,dest,src_id,dest_id,src_vid,dest_vid,src_name,dest_name} = commonData;
  const todaysDate = getDateObj();
  const maxDateAllowed = getDateObj();
  maxDateAllowed.setMonth(maxDateAllowed.getMonth() + 12);

  const [isCalendarOpen, toggleCalendar] = useState(false);
  let storedDate = dojObj ? getDateObj(dojObj) : todaysDate;
  let dateObj = storedDate.getTime() > todaysDate.getTime() ? storedDate :todaysDate;
 
  const [selectedDate, setSelectedDate] = useState(dateObj);
  const [isInputEmpty,setInputEmpty] = useState(false);
  const [srcState, setSrcState] = useState('')
  const [destState, setDestState] = useState('')
  let source =  useRef(getautoSuggestInit({id:src_vid,n:src}));
  let destination=  useRef(getautoSuggestInit({id:dest_vid,n:dest}));
  const [isSrcDestSame,setSrcDestSame] = useState(false);
  let srcInputBoxId  = props.srcInputBoxId ||  "autosuggestBusSRPSrc";
  let destInputBoxId = props.destInputBoxId || "autosuggestBusSRPDest";
  useEffect(() => {
    setSelectedDate(dojObj)
   
  }, [doj])
  useEffect(()=>{
  
    if(src && dest){
    source.current={id:src_vid,n:src,dn:src};
    destination.current= {id:dest_vid,n:dest,dn:dest} ;

    document.getElementById(srcInputBoxId).value= src;
    document.getElementById(destInputBoxId).value= dest;
    }
  },[src,dest,src_vid,dest_vid])
  
  const getUrl = value => {
    return searchWidgetLocationSearchURL(value);
  };
  const massageData = item => {
    return item;
  };
  const itemToString = item => {
    return item.n;
  };
  const List = props => {
    return <AutoS.AutoSuggestList>{props.children}</AutoS.AutoSuggestList>;
  };

  const Input = forwardRef((props, ref) => {
    return <S.SearchInputStyle 
    spellCheck={false}
      
    type="text" {...props} id={srcInputBoxId} data-testid={srcInputBoxId} name={srcInputBoxId} className={props.value ? '' : ''}
    autoFocus={true}
     
    onFocus={(evt)=>{
      document.getElementById(srcInputBoxId).value= source.current.n;

      document.getElementById(destInputBoxId).value= destination.current.n;
    }}

    />;
  });

  const InputD = forwardRef((props, ref) => {
    
    return <S.SearchInputStyle 
    spellCheck={false}
    type="text" {...props} id={destInputBoxId} data-testid={destInputBoxId} name={destInputBoxId} className={props.value ? '' : ''}
    autoFocus={false}
    onFocus={(evt)=>{
     
      document.getElementById(srcInputBoxId).value= source.current.n;
      document.getElementById(destInputBoxId).value= destination.current.n;

   
    }}
/>;
  });
  const itemElement = item => {
    return <AutoS.ListItem>{item.dn}</AutoS.ListItem>;
  };
  const onSourceSelect = item => {
    source.current = item;
    let journeyParamsObj = {
      src:source.current.n,
      dest:destination.current.n,
      src_vid:source.current.id,
      dest_vid:destination.current.id,
      doj: dateFormat(selectedDate, 'yyyymmdd'),
      journeyType: 'onw',
      flavour: 'dweb',
      dojObj: selectedDate,
      src_name:source.current.n,
      dest_name:destination.current.n,
    };

    dispatch(updateJourneyParams(journeyParamsObj))
                
     if(source.current.n && destination.current.n){
      setInputEmpty(false);
     }
     setSrcState(item?.p || '')
  };
  const onDestiantionSelect = item => {
    destination.current = item;
  
    let journeyParamsObj = {
      src:source.current.n,
      dest:destination.current.n,
      src_vid:source.current.id,
      dest_vid:destination.current.id,
      doj: dateFormat(selectedDate, 'yyyymmdd'),
      journeyType: 'onw',
      flavour: 'dweb',
      dojObj: selectedDate,
      src_name:source.current.n,
      dest_name:destination.current.n,
    };

    dispatch(updateJourneyParams(journeyParamsObj))
    
        if(source.current.n && destination.current.n){
          setInputEmpty(false);
         }
    setDestState(item?.p || '')
  };
  const onSwap = () => {
    const temp = destination.current;
    destination.current = source.current;
    source.current = temp;
    let journeyParamsObj = {
      src:source.current.n,
      dest:destination.current.n,
      src_vid:source.current.id,
      dest_vid:destination.current.id,
      doj: dateFormat(selectedDate, 'yyyymmdd'),
      journeyType: 'onw',
      flavour: 'dweb',
      dojObj: selectedDate,
      src_name:source.current.n,
      dest_name:destination.current.n,
    };

    dispatch(updateJourneyParams(journeyParamsObj))
    document.getElementById(srcInputBoxId).value= source.current.n;
    document.getElementById(destInputBoxId).value= destination.current.n;
   
  };

  const dateOnClickHandler = dateObj => {
    setSelectedDate(dateObj);
    toggleCalendar(!isCalendarOpen);
  };

  const getClassName = (dateObj: Date) => {
    const types = ['selectedDate', 'leftactive', 'rightactive', 'partial'];
    return types[0];
  };
  let inputDErr = function(){
  

    if(isInputEmpty && !destination.current.n){
      return (<S.SearchLabelStyle className='error'>Please enter the to location</S.SearchLabelStyle>)
    }
    if(isSrcDestSame){
      return (     
        <S.SearchLabelStyle className='error'>Source and Destination can't be same</S.SearchLabelStyle>
      )
    
    }
     return ( <S.SearchLabelStyle>TO</S.SearchLabelStyle>)     
   }()
   let inputErr = function(){
    if(isInputEmpty && !source.current.n){
      return(<S.SearchLabelStyle className='error'>Please enter the FROM location</S.SearchLabelStyle>)
    }
    
    
 
    if(isSrcDestSame){
      return (     
        <S.SearchLabelStyle className='error'>Source and Destination can't be same</S.SearchLabelStyle> 
      
      )
    
    }
     return (     <S.SearchLabelStyle>FROM</S.SearchLabelStyle> )     
   }()
  
  
  return (
    <S.SearchWidgetLayoutDiv>
      <S.SearchWidgetInnerLayoutDiv>
        <S.InnerWrapperDiv>
          <S.SourceDestinationOuterWrapperDiv>
            <S.FromOuterWrapperDiv>
              {' '}
              {inputErr}
              <AutoSuggest
                placeholder={FROM_PLACEHOLDER}
                getUrl={getUrl} // placeholder for input
                massageData={massageData} // in case you want to perform any processing on data call this function
                onItemSelection={onSourceSelect}
                itemToString={itemToString} // display
                itemElement={itemElement}
                Input={Input} // input field (default is plain input box as of now. can provide some                                              default css eventually)
                List={List}
                initialInputValue={source.current.n || ''}
                name={srcInputBoxId}
                id={srcInputBoxId}
              ></AutoSuggest>
            </S.FromOuterWrapperDiv>
            <S.IconOuterWrapperDiv onClick={onSwap}>
              <Icon
                name="SwpIcon"
                styleProps={{fill: 'white', width: '3.5rem', height: '3.5rem'}}
              />
            </S.IconOuterWrapperDiv>
            <S.FromOuterWrapperDiv>
              {' '}
              {inputDErr}
              <AutoSuggest
                placeholder={TO_PLACEHOLDER}
                getUrl={getUrl} // placeholder for input
                massageData={massageData} // in case you want to perform any processing on data call this function
                onItemSelection={onDestiantionSelect}
                itemToString={itemToString} // display
                itemElement={itemElement}
                Input={InputD} // input field (default is plain input box as of now. can provide some                                              default css eventually)
                List={List}
                initialInputValue={destination.current.n || ''}
                name={destInputBoxId}
                id={destInputBoxId}
           
              ></AutoSuggest>
            </S.FromOuterWrapperDiv>
          </S.SourceDestinationOuterWrapperDiv>

          <S.DepartureOuterWrapperDiv>
            <S.SearchLabelStyle>DEPARTURE DATE</S.SearchLabelStyle>
            {isCalendarOpen ? (
              <S.CalendarBlockOuterWrapper ref={calendarBlockRef}>
                <CalendarView
                  dateConfigForMonthToBeDisplayed={selectedDate || todaysDate}
                  minDateAllowed={todaysDate}
                  maxDateAllowed={maxDateAllowed}
                  renderDateItem={({value, dateObj,index}) => {
                      if (!value) {
                        return (
                          <li key={"empty"+index}>
                            <span></span>
                          </li>
                        );
                      }
                    

                    let isValid = true;

                    dateObj.setHours(0, 0, 0, 0);

                    todaysDate.setHours(0, 0, 0, 0);
                    isValid =
                      dateObj.getTime() >= todaysDate.getTime() &&
                      dateObj.getTime() < maxDateAllowed.getTime();

                    return (
                      <li
                        className={
                          dateFormat(selectedDate, 'dmmyyyy') === dateFormat(dateObj, 'dmmyyyy')
                            ? getClassName(dateObj)
                            : ''
                        }
                        key={value + dateObj.getTime()}
                        style={isValid ? {color: 'black'} : {opacity: '0.4', color: 'grey'}}
                        onClick={() => {
                          isValid ? dateOnClickHandler(dateObj) : () => {};
                        }}
                      >
                        <span>{value}</span>
                      </li>
                    );
                  }}
                />
              </S.CalendarBlockOuterWrapper>
            ) : null}
            <S.DepartureInputStyle
              type="text"
              data-testid="openCheckinCalendar"
              value={dateFormat(selectedDate, 'mmm d, yyyy')}
              onChange={()=>{}}
              onClick={() => {
                toggleCalendar(!isCalendarOpen);
              }}
            />
          </S.DepartureOuterWrapperDiv>

          <S.UpdateWrapperDiv     onClick={() => {
            const srcValue = document.getElementById(srcInputBoxId).value;
            const destValue = document.getElementById(destInputBoxId).value;
                    setInputEmpty(false);
                    let journeyParamsObj = {
                      src:source.current.n,
                      dest:destination.current.n,
                      src_vid:source.current.id,
                      dest_vid:destination.current.id,
                      doj: dateFormat(selectedDate, 'yyyymmdd'),
                      journeyType: 'onw',
                      flavour: 'dweb',
                      dojObj: selectedDate,
                      src_name:source.current.n,
                      dest_name:destination.current.n,
                    };
                 if(!srcValue){
                   journeyParamsObj.src = '' 
                   journeyParamsObj.src_vid =''  
              
                
                 }
                 if(!destValue){
                  journeyParamsObj.dest = '' 
                  journeyParamsObj.dest_vid =''  
                
                 }
                  if(srcValue && destValue && srcValue === destValue){
             setSrcDestSame(true);
             return;
           }
          
                   if( srcValue&& destValue){
                    

                    setSrcDestSame(false);
                    dispatch(updateSelectedBus(''));
                    if(props.updateSearchCB){

                      dispatch(updateJourneyParams(journeyParamsObj))
                      dispatch({type:'INSERT_ROUTE_STATE', actionData: {srcState, destState}})
                     props.updateSearchCB({selectedDate,src_name:source.current.n,dest_name:destination.current.n,src_vid: source.current.id,
                      dest_vid: destination.current.id}); 
                     }else{

                     
                    dispatch(
                      fetchSrpDataThunk({
                        src: source.current.n,
                        dest: destination.current.n,
                        src_id: source.current.id,
                        dest_id: destination.current.id,
                        doj: dateFormat(selectedDate, 'yyyymmdd'),
                        src_name:source.current.n,
                        dest_name:destination.current.n
                      }),
                    );
                     }
                    let recentSearches = getter('busRecentSearches');
                    if (!recentSearches) {
                      recentSearches = {};
                    }
                  
                    const srcIndex = source.current.n.indexOf(',');
                    const destIndex = destination.current.n.indexOf(',');
                    const viewSrc =
                      srcIndex !== -1 ? source.current.n.substring(0, srcIndex) : source.current.n;
                    const viewDest =
                      destIndex !== -1
                        ? destination.current.n.substring(0, destIndex)
                        : destination.current.n;
                    const viewDate = dateFormat(selectedDate, 'dS mmm yyyy');
                    const keyDate = dateFormat(selectedDate, 'ddmmyyyy');
                    let key = `${viewSrc}-${viewDest}-${keyDate}`;
                    recentSearches[key] = {
                      src: viewSrc,
                      dest: viewDest,
                      date: viewDate,
                      src_vid: source.current.id,
                      dest_vid: destination.current.id,
                      selectedDate,
                    };
        
                    setter('busRecentSearches', recentSearches);
                 
                    pushga({
                      event: SrpGAEvents.actions.bus_updatesearch,
                      eventCategory: SrpGAEvents.category,
                      eventAction: SrpGAEvents.actions.bus_updatesearch,
                      eventLabel:`${source.current.n}-${destination.current.n}`
                    });
                    
                    const eventDetails = {
                      search : {
                          searchId: `${viewSrc}-${viewDest}-${dateFormat(selectedDate, 'yyyymmdd')}`,
                       },
                      cta: ctaHelper(['Update_Search',CTA_TYPE.BUTTON,'Header', 'SRP']),
                      booking: {
                          routeCity: `${viewSrc}-${viewDest}`,
                          routeState: `${srcState}-${destState}`,
                          daysToTrip: `${calculateDaysToTrip(selectedDate)}`,
                          departureDate: `${convert_yyyymmdd_to_dd_mm_dddd(dateFormat(selectedDate, 'yyyymmdd'))}`,
                      },
                    };
                    pushOmniEvents({ eventName: 'busUpdateSearch', details: eventDetails })
                    let webEngageEvtDetails = {
                      fb_bus_duration: `8h20m`,
                      fb_origin_country:`India`,
                      fb_platform:'GI',
                      fb_origin:`${viewSrc}`,
                      fb_destination:`${viewDest}`,
                      fb_departing_departure_date:`${dateFormat(selectedDate, 'yyyymmdd')}`,
                    }
                    pushWebEngageEvents({eventName : 'googleRT', details : webEngageEvtDetails})
                   }else{
                    dispatch(updateJourneyParams(journeyParamsObj))
                
                     setInputEmpty(true);
                   }
                   replaceSRPUrlState({
                      history,
                      search:window.location.search,
                      keyName:'bid',
                      inputValues:{
                        src_name:source.current.n,
                        dest_name: destination.current.n,
                        src_vid: source.current.id,
                        dest_vid: destination.current.id,
                        selectedDate:selectedDate
                     
                      }

                   })
                   props.setSelectedFilters(getInitSelectedFilters(true));
                   props.clearHorizontalFilterCards(true)
                   const idOfElToScrollTo = "#srpCardLayout";
       
                   scrollEletoView(idOfElToScrollTo,{
                    behavior: 'smooth',block:'start'
               });
                
                  }}
              >
            <SecondaryButton>
              <S.PayBtnWrapDiv>
                <S.PayTxtSpan
                 data-testid="searchBusBtnSRP"
                >
                  UPDATE SEARCH
                </S.PayTxtSpan>
              </S.PayBtnWrapDiv>
            </SecondaryButton>
          </S.UpdateWrapperDiv>
        </S.InnerWrapperDiv>
      </S.SearchWidgetInnerLayoutDiv>
    </S.SearchWidgetLayoutDiv>
  );
};

export default SearchWidget;
function getautoSuggestInit(data ?: {id:string | number ; n:string}) {

  const {id,n} = data || {};
 
  return {
    id: id ||  '',
    n: n || '',
    dn: n || '',
  };
}

